import { DeviceDetection } from './lib/device_detection'

const isMobile = () => DeviceDetection.isMobile()

const hide = el => el.classList.add('hidden')
const hideOsSpecificElements = () => {
  if (!isChromeDesktop()) { hideSelector('.app-chrome-desktop') }
  if (!isFirefoxDesktop()) { hideSelector('.app-firefox-desktop') }
  if (!isSafariDesktop()) { hideSelector('.app-safari-desktop') }
  if (!isAndroid()) { hideSelector('.app-android') }
  if (!isIos()) { hideSelector('.app-ios') }
}
const hideSelector = (selector, optionalScope) => {
  const scope = optionalScope || window.document
  scope.querySelectorAll(selector).forEach(el => hide(el))
}
const isAndroid = () => DeviceDetection.isAndroid()
const isChromeDesktop = () => DeviceDetection.isChromeDesktop()
const isFirefoxDesktop = () => DeviceDetection.isFirefoxDesktop()
const isIos = () => DeviceDetection.isIOS()
const isMaybeIOSSimulator = () => DeviceDetection.isMaybeIOSSimulator()
const isSafari = () => DeviceDetection.isSafari()
const isSafariDesktop = () => DeviceDetection.isSafariDesktop()
const isPwa = () => DeviceDetection.isPWA()
const show = (el) => el.classList.remove('hidden')

export {
  hide,
  hideSelector,
  hideOsSpecificElements,
  isAndroid,
  isChromeDesktop,
  isFirefoxDesktop,
  isIos,
  isMobile,
  isPwa,
  isSafari,
  isSafariDesktop,
  isMaybeIOSSimulator,
  show
}
